import { Divider } from "antd";
import ExerciseDashboard from "./ExerciseDashboard";

export default function TeacherDashboard({ selectedTerm }) {
    return <>
        <Divider>Sinh viên học trong kỳ</Divider>
        <ExerciseDashboard selectedTerm={selectedTerm}/>
    </>
}
